import { Button } from '../ui/button';

export const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'USD'
    }).format(amount);
};

export const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
};

export const formatTime = (dateStr) => {
    return new Date(dateStr).toLocaleTimeString('es-ES', { 
        hour: '2-digit', 
        minute: '2-digit',
        hour12: true 
    });
};

export const InvoiceSummary = ({ invoices, formatCurrency, userRole, summary = null }) => {
    const loadedConfirmed = invoices.filter(i => i.confirmed === true);
    const loadedPending = invoices.filter(i => i.confirmed !== true);
    // Server totals (whole filter) win over the loaded page so every role sees the same numbers
    const cCount = summary ? summary.confirmed_count : loadedConfirmed.length;
    const cTotal = summary ? summary.confirmed_total : loadedConfirmed.reduce((s, i) => s + i.amount, 0);
    const pCount = summary ? summary.pending_count : loadedPending.length;
    const pTotal = summary ? summary.pending_total : loadedPending.reduce((s, i) => s + i.amount, 0);
    return (
    <div className="mt-4 pt-4 border-t border-slate-200 flex flex-wrap gap-4 text-sm" data-testid="dashboard-invoice-summary">
        <div className="bg-green-50 px-4 py-2 rounded-lg">
            <span className="text-green-600 font-medium" data-testid="dash-summary-confirmed-count">
                Confirmadas: {cCount}
            </span>
            <span className="text-green-700 font-bold ml-2" data-testid="dash-summary-confirmed-total">
                {formatCurrency(cTotal)}
            </span>
        </div>
        <div className="bg-amber-50 px-4 py-2 rounded-lg">
            <span className="text-amber-600 font-medium">
                Pendientes: {pCount}
            </span>
            <span className="text-amber-700 font-bold ml-2">
                {formatCurrency(pTotal)}
            </span>
        </div>
        <div className="bg-sky-50 px-4 py-2 rounded-lg">
            <span className="text-sky-600 font-medium">
                Total:
            </span>
            <span className="text-sky-700 font-bold ml-2">
                {formatCurrency(cTotal + pTotal)}
            </span>
        </div>
        {/* 3% fee from confirmed - Only for admin */}
        {userRole === 'admin' && (
            <div className="bg-purple-50 px-4 py-2 rounded-lg">
                <span className="text-purple-600 font-medium">
                    3%:
                </span>
                <span className="text-purple-700 font-bold ml-2">
                    {formatCurrency(cTotal * 0.03)}
                </span>
            </div>
        )}
    </div>
    );
};

export const LoadMoreButton = ({ hasMore, visibleCount, totalCount, onLoadMore, testId }) => {
    if (!hasMore) return null;
    
    return (
        <div className="mt-4 text-left">
            <Button
                variant="outline"
                onClick={onLoadMore}
                className="text-sky-600 border-sky-200 hover:bg-sky-50"
                data-testid={testId}
            >
                Cargar más ({visibleCount} de {totalCount})
            </Button>
        </div>
    );
};

export const EmptyState = ({ icon: Icon, title, subtitle }) => (
    <div className="empty-state py-8">
        <Icon className="w-12 h-12 text-slate-300 mx-auto mb-3" />
        <p className="text-slate-500">{title}</p>
        {subtitle && <p className="text-slate-400 text-sm mt-1">{subtitle}</p>}
    </div>
);

export const LoadingSpinner = () => (
    <div className="flex items-center justify-center h-64">
        <div className="spinner"></div>
    </div>
);
